import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M11.992 17.554A7.815 7.815 0 0 0 17.812 10 7.795 7.795 0 0 0 10 2.187c-5.211 0-7.813 4.344-7.813 4.344m0 0V2.968m0 3.563h3.469"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-dasharray": "3 3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M2.187 10c0 4.313 3.5 7.813 7.813 7.813"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m12.86 12.452-3.142-1.874v-4.04"
    }, null, -1)
  ]))]))
}
export default { render: render }